import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll,ModalController} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { MzModalPage } from 'src/app/page/nestle/mz-modal/mz-modal.page';
declare var app;
@Component({
  selector: 'app-product-storage',
  templateUrl: './product-storage.component.html',
  styleUrls: ['./product-storage.component.scss']
})
export class ProductStorageComponent   extends GridBaseCase {
  CustomInterfaceOptions: any = {
    header: '产品列表',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  isSelectCahage: boolean = false;//是否多次点击
  // dataArrayList: Array<any> = [];
  productArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName: string = null;
  isAddProduct: boolean = true;//是否可以添加产品
  isSubmitData: boolean = true;//是否可以提交数据
  isAndroid4: boolean = false;//安卓4以下
  max: any;//最大日期
  isreturnGoods: boolean = false;//是否退货页面
  Remark:string="";//消费者退货备注
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal:ModalController,
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if (this.pageName == "ReturnGoods") {//消费者退货
      this.isreturnGoods = true;
      this.baseService.arrayData = [];
    }
    // this.getProductList();
    this.baseService.FixedSubmitBtn.configName = "ProductStorage";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "提交";
    this.baseService.FixedSubmitBtn.type = 23;

    this.isAndroid4 = this.com.Isandroidversion;
    this.max = this.com.TenTime;
  }
  EventLink(event, item) {
    // console.log(item);
    localStorage.setItem("information", JSON.stringify(item));
    this.com.setHistoryUrl();
    // this.router.navigate([event.url + item.id.value]);
    this.com.Go(event.url + item.id.value);
  }

  /**
   * 生产日期android5以下
   * @param item 选中的数据
   */
  EventClickTime(item){
    // const that=this;
    // let val = item.orderCreateDate.value || "";
    // let obj = {};
    // if(val){
    //   const _val = val.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + _month + "-" + _day;
    //   obj["value"]=d;
    // }else{
    //   const _date = new Date();
    //   obj["value"] = _date.getFullYear()+"-"+(_date.getMonth() + 1)+"-"+_date.getDate();
    // }
    // obj["format"]="yyyymmdd";
    // that.native.IosselectDateTime(obj).then(data=>{
    //   const _val = data.value.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + (_month < 10?("0" + _month):_month) + "-" + (_day < 10?("0" + _day):_day);
    //   item.orderCreateDate.value = d;
    // }).catch(eror=>{
    // });
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount ==  that.baseService.arrayData.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      if (this.pageName == "ReturnGoods") {//消费者退货 
       
      return;
      } 
      that.PageNumber++;
      this.LoadData(that.PageNumber);

    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    
     body.ConfigName="TBProductInventoryXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData=[];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
         data.Status.Datas.forEach(items=>{
            items.a_count= items.a_count;
            items.stock=0;
         });
        that.baseService.arrayData=data.Status.Datas;
        console.log( that.baseService.arrayData);
         that.baseService.arrayData.forEach(item=>{
                    if(!item.a_count){
                      item.a_count=0;
                    }
                    if(!item.stock){
                      item.stock=0;
                    }
          
        });
        // console.log(that.dataArrayList,"dataArrayList");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount ==  that.baseService.arrayData.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }



   /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    const that=this;
    console.log("下拉率先你");
    console.warn("提示1");
    console.log(that.baseService.ListData);
    console.log("提示2");
    console.log(that.baseService.arrayData)
    event.target.pullMax=500;
    event.target.pullMin=100;
    event.target.complete();
  }
  
  /**
   * 分销人
   * @param item 
   */
  onInput(item, event) {
    let that = this;
    // console.log(1);
    setTimeout(() => {
      if (event.target.value) {
        let numvalue: any = this.com.GetNumber(event.target.value);
        if (numvalue) {
          item.stock = numvalue;
          event.target.value = numvalue;
        } else {
          item.stock = 0;
          event.target.value = 0;
        }
      } else {
        event.target.value = null;
        item.stock = 0;
      }
    }, 400);
  }
  Eventdatetime(event, item) {
    item.orderCreateDate.value = event.detail.value;
  }
  
  /**
   * 提交数据
   */
  EventSubmitClick(){
   const that = this;
    let arrayDataList: Array<any> = new Array<any>();
    console.log( that.baseService.arrayData,"拿到的数据");
    that.baseService.arrayData.forEach(items => {
     if(items.a_count || items.stock){
        // 接口拼接
      let _obj = {};
      _obj["FK_TBProductInformation_ID"] = items.FK_TBProductInformation_ID;
      // _obj["FK_TBProductStock_ID"] = items.FK_TBProductStock_ID;
   
      let Barcodes:any={};
      _obj["Barcodes"]=new Array<any>();
      if (items.IntegralCodeDetailList && items.IntegralCodeDetailList.length > 0) {
     
        if(items.IntegralCodeDetailList.length>1){
          Barcodes["BoxBarcode"]=items.IntegralCodeDetailList[0]["BoxBarcode"];
          let longCode="";
          items.IntegralCodeDetailList.forEach(code=>{
            if(code.LogisticsCode){
              longCode+=code.LogisticsCode+",";
            }
            
          })
          Barcodes["TankBarcode"]=longCode.substring(0,longCode.length-1);
        }else{
          Barcodes["BoxBarcode"]=items.IntegralCodeDetailList[0]["BoxBarcode"];
          Barcodes["TankBarcode"]=items.IntegralCodeDetailList[0]["LogisticsCode"];
        }
        Barcodes["Count"] = items.a_count;//箱码或者罐码
        _obj["Barcodes"].push(Barcodes);
      }
      _obj["ScanCount"] = items.a_count || 0;//箱码或者罐码
      _obj["NoScanCount"] = items.stock || 0;//箱码或者罐码
      arrayDataList.push(_obj);
     }
    });
    if(arrayDataList.length<=0){
      that.msg.Alert("请先操作入库");
      return;
    }
    console.log(arrayDataList,"信息");
  //  debugger;
  // return;
  //  产品入库接口调用
   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
   let body = new WebParameterContext();
   body.Account = that.com.GetAccount;
   body.ConfigName = "TBProductPurchase";
   body.OpType = "add";
   body.ConfigType = "form";
   body.Client.PageName = PageName;
   body.Client.ApiType = "Element";
   body.Client.ClientType = 2;
   body.RequestBody = JSON.stringify(arrayDataList);
   that.msg.Confirm("确认提交吗？", "取消", "确定", "", false).then(res => {
    if (res) {
     that.msg.Loading("请求中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if (data.ResponseMessage.Success) {
          console.log(data);
          that.msg.Alert("提交成功").then(res=>{
            that.com.goBack();
          });
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        load.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
      load.present();
     });
    }
  })

  }




}